import { render, staticRenderFns } from "./SettingSuggestionNew.vue?vue&type=template&id=45de8eaf&scoped=true&"
import script from "./SettingSuggestionNew.vue?vue&type=script&lang=js&"
export * from "./SettingSuggestionNew.vue?vue&type=script&lang=js&"
import style0 from "./SettingSuggestionNew.vue?vue&type=style&index=0&id=45de8eaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de8eaf",
  null
  
)

export default component.exports